// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"123":"52940b5b","152":"89fd2349","443":"52b917ca"}[chunkId] + ".css";
};